import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = ({ onJoinWaitlist }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'mx-4 mt-4 rounded-full bg-white/80 backdrop-blur-xl border border-black/10 shadow-sm'
          : 'mt-6 bg-transparent'
      }`}
      style={{ maxWidth: isScrolled ? 'calc(100% - 32px)' : '100%' }}
    >
      <div className="container mx-auto">
        <nav className="flex items-center justify-between h-14 px-4">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-[#8FEC78] flex items-center justify-center">
              <span className="text-[#003720] font-bold text-sm">C</span>
            </div>
            <span
              className="font-semibold text-lg"
              style={{ color: isScrolled ? 'var(--text-primary)' : '#FFFFFF' }}
            >
              Crew Up
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1">
            <button
              onClick={() => scrollToSection('how-it-works')}
              className={`nav-link ${!isScrolled ? 'nav-link-light' : ''}`}
            >
              How it Works
            </button>
            <button
              onClick={() => scrollToSection('for-businesses')}
              className={`nav-link ${!isScrolled ? 'nav-link-light' : ''}`}
            >
              For Businesses
            </button>
            <button
              onClick={() => scrollToSection('for-staff')}
              className={`nav-link ${!isScrolled ? 'nav-link-light' : ''}`}
            >
              For Staff
            </button>
            <button
              onClick={() => scrollToSection('trust')}
              className={`nav-link ${!isScrolled ? 'nav-link-light' : ''}`}
            >
              Trust & Safety
            </button>
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:block">
            <button onClick={onJoinWaitlist} className="btn-primary text-sm py-2.5 px-5">
              Join Waitlist
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg transition-colors"
            style={{ color: isScrolled ? 'var(--text-primary)' : '#FFFFFF' }}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 mt-2 mx-4 bg-white rounded-2xl border border-black/10 shadow-lg p-4">
            <div className="flex flex-col gap-2">
              <button onClick={() => scrollToSection('how-it-works')} className="nav-link text-left w-full">
                How it Works
              </button>
              <button onClick={() => scrollToSection('for-businesses')} className="nav-link text-left w-full">
                For Businesses
              </button>
              <button onClick={() => scrollToSection('for-staff')} className="nav-link text-left w-full">
                For Staff
              </button>
              <button onClick={() => scrollToSection('trust')} className="nav-link text-left w-full">
                Trust & Safety
              </button>
              <div className="pt-2 border-t border-black/10 mt-2">
                <button onClick={onJoinWaitlist} className="btn-primary w-full">
                  Join Waitlist
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
